var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlankIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592,
    y: 312,
    width: 96,
    height: 96
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-592 -312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673 337.6C668.7 327.7 660.9 320 650.8 316L649.3 319.7C658.3 323.3 665.4 330.2 669.3 339.2 673.1 348.2 673.3 358.1 669.7 367.1 666.1 376.1 659.2 383.2 650.2 387.1 641.2 390.9 631.3 391.1 622.3 387.5L620.8 391.2C624.5 392.7 628.4 393.6 632.3 393.9L632.3 397.8 612.3 397.8 612.3 403.8 660.3 403.8 660.3 397.8 640.3 397.8 640.3 393.8C644.2 393.4 648 392.3 651.8 390.8 661.8 386.5 669.4 378.7 673.4 368.6 677.4 358.5 677.3 347.6 673 337.6Z",
    stroke: "#000000",
    strokeWidth: 1.33333,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.5 353.6C668.5 371.549 653.949 386.1 636 386.1 618.051 386.1 603.5 371.549 603.5 353.6 603.5 335.651 618.051 321.1 636 321.1 653.949 321.1 668.5 335.651 668.5 353.6Z",
    stroke: "#000000",
    strokeWidth: 1.33333,
    fill: "#FFFFFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankIcon);
export default __webpack_public_path__ + "static/media/Blank-icon.a27e9bafc4b78072165904685ccc540c.svg";
export { ForwardRef as ReactComponent };